import { AdminTabs } from '@pages/admin-view/admin-view-routes.names';

export const BusinessAppointments = 'appointments';

export const AdminViewTabAppointments = `${AdminTabs}/${BusinessAppointments}`;
